export default __webpack_public_path__ + "c696540fb016e1f78c3d4a3bb3ec4b76.png";